'use strict';

import {gsap} from 'gsap';

const $ = jQuery.noConflict();

$(function() {

	const awardsCarousel = {

		init: function() {
			this.cacheDOM();
			if (!this.$marquees.length || this.prefersReducedMotion) {
				return;
			}
			this.buildMarquees();
			this.bindEvents();
		},

		cacheDOM: function() {
			this.$marquees = $('.js-awards-carousel');
			// scroll speed in pixels per second
			this.speed = 60;
			this.windowWidth = window.innerWidth;
			this.resizeTimer = null;
			this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
		},

		bindEvents: function() {
			$(window).on('resize.awardsCarousel', this.handleResize.bind(this));
		},

		buildMarquees: function() {
			this.$marquees.each((_, marquee) => this.buildMarquee(marquee));
		},

		buildMarquee: function(marquee) {
			const track = marquee.querySelector('.js-awards-carousel-track');
			const set = track ? track.querySelector('.js-awards-carousel-set') : null;
			if (!track || !set) {
				return;
			}

			const setWidth = set.offsetWidth;
			if (!setWidth) {
				return;
			}

			const minTrackWidth = marquee.offsetWidth + setWidth * 2;
			let currentWidth = setWidth;
			while (currentWidth < minTrackWidth) {
				track.append(set.cloneNode(true));
				currentWidth += setWidth;
			}

			marquee.marqueeTween = gsap.fromTo(track,
				{x: 0},
				{
					x: -setWidth,
					duration: setWidth / this.speed,
					ease: 'none',
					repeat: -1,
				}
			);

			this.observe(marquee);
		},

		observe: function(marquee) {
			if (!('IntersectionObserver' in window)) {
				return;
			}

			const observer = new IntersectionObserver((entries) => {
				entries.forEach((entry) => {
					if (!marquee.marqueeTween) {
						return;
					}
					if (entry.isIntersecting) {
						marquee.marqueeTween.resume();
					} else {
						marquee.marqueeTween.pause();
					}
				});
			});

			observer.observe(marquee);
			marquee.marqueeObserver = observer;
		},

		handleResize: function() {
			if (window.innerWidth === this.windowWidth) {
				return;
			}
			this.windowWidth = window.innerWidth;

			clearTimeout(this.resizeTimer);
			this.resizeTimer = setTimeout(this.rebuild.bind(this), 250);
		},

		rebuild: function() {
			this.$marquees.each((_, marquee) => {
				if (marquee.marqueeTween) {
					marquee.marqueeTween.kill();
					marquee.marqueeTween = null;
				}
				if (marquee.marqueeObserver) {
					marquee.marqueeObserver.disconnect();
					marquee.marqueeObserver = null;
				}

				const track = marquee.querySelector('.js-awards-carousel-track');
				if (!track) {
					return;
				}

				const sets = track.querySelectorAll('.js-awards-carousel-set');
				for (let i = sets.length - 1; i > 0; i--) {
					sets[i].remove();
				}
				gsap.set(track, {x: 0});

				this.buildMarquee(marquee);
			});
		},

	};

	awardsCarousel.init();

});
